import React, { useEffect, useState } from "react";
import axios from "axios";
import { Button, Modal, Form, InputGroup } from "react-bootstrap";
import { BASE_URL } from "config/config";
import FolderCard from "@pages/ged/components/FolderCard/FolderCard";

import CreateDocumentModal from "@pages/ged/components/CreateDocumentModal/CreateDocumentModal";
import { DocumentCard } from "@pages/ged/components/DocumentCard/DocumentCard";
import { useSelector } from "react-redux";
import "./FolderManager.scss";
import { Search } from "@mui/icons-material";
import { FIleIcon } from "@assets/icons/FIleIcon";
import { FolderIcon } from "@assets/icons/FolderIcon";
import { useTranslation } from "react-i18next";
const FolderManager = () => {
  // États principaux
  const { t } = useTranslation();
  const [folders, setFolders] = useState([]);
  const [foldersChild, setFoldersChild] = useState([]);
  const [foldersAdd, setFoldersAdd] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [folderSearchResults, setFolderSearchResults] = useState([]);
  const [documentSearchResults, setDocumentSearchResults] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [newFolderName, setNewFolderName] = useState("");
  const [parentId, setParentId] = useState(null);
  const [showDocumentModal, setShowDocumentModal] = useState(false);
  const currentUser = useSelector((state) => state.auth.user);
  const companyId = currentUser?.companyId?._id;
  console.log(companyId);
  // ==========================
  // 1️⃣ Récupérer tous les dossiers
  // ==========================
  const fetchFolders = async () => {
    try {
      const res = await axios.get(`${BASE_URL}folders/company/${companyId}`);
      const data = res?.data?.data || [];
      setFolders(data.filter((f) => !f.parentId));
      setFoldersAdd(data);
    } catch (err) {
      console.error("Erreur fetch folders:", err);
    }
  };

  // ==========================
  // 2️⃣ Récupérer sous-dossiers (enfants)
  // ==========================
  const fetchFoldersChild = async () => {
    try {
      const res = await axios.get(`${BASE_URL}folders/tree/${companyId}`);
      setFoldersChild(res?.data?.data || []);
    } catch (err) {
      console.error("Erreur fetch folders child:", err);
    }
  };

  // ==========================
  // 3️⃣ Créer un nouveau dossier
  // ==========================
  const createFolder = async () => {
    if (!newFolderName.trim()) return alert("Nom obligatoire");
    try {
      await axios.post(`${BASE_URL}folders`, {
        name: newFolderName,
        parentId,
        companyId: companyId,
      });
      setNewFolderName("");
      setParentId(null);
      setShowModal(false);
      fetchFolders();
    } catch (err) {
      console.error("Erreur création dossier:", err);
    }
  };

  // ==========================
  // 4️⃣ Recherche dossiers
  // ==========================
  const searchFolders = async () => {
    if (!searchQuery.trim()) {
      setFolderSearchResults([]);
      return;
    }
    try {
      const res = await axios.get(
        `${BASE_URL}folders/folder/search/${companyId}?query=${searchQuery}`
      );
      setFolderSearchResults(res?.data?.data || []);
    } catch (err) {
      console.error("Erreur recherche folders:", err);
    }
  };

  // ==========================
  // 5️⃣ Recherche documents
  // ==========================
  const searchDocuments = async () => {
    if (!searchQuery.trim()) {
      setDocumentSearchResults([]);
      return;
    }
    try {
      const res = await axios.get(
        `${BASE_URL}documentsFile/doc/search/${companyId}?query=${searchQuery}`
      );
      setDocumentSearchResults(res?.data?.data || []);
    } catch (err) {
      console.error("Erreur recherche documents:", err);
    }
  };

  // ==========================
  // 6️⃣ Fonction récursive pour options parent
  // ==========================
  const renderFolderOptions = (foldersChild, level = 0) => {
    return foldersChild.flatMap((folder) => [
      <option key={folder._id} value={folder._id}>
        {Array(level * 4)
          .fill("\u00A0")
          .join("")}
        {folder.name}
      </option>,
      folder.children ? renderFolderOptions(folder.children, level + 1) : [],
    ]);
  };

  // ==========================
  // 7️⃣ useEffect initial
  // ==========================
  useEffect(() => {
    fetchFolders();
    fetchFoldersChild();
  }, []);

  // ==========================
  // 8️⃣ Gestion de la recherche combinée
  // ==========================
  const handleSearch = () => {
    searchFolders();
    searchDocuments();
  };
  function getImageURL(id) {
    return `${BASE_URL}documentsFile/${id}/file`;
  }
  // ==========================
  // JSX
  // ==========================
  return (
    <div className="documents-page">
      {/* Header Section */}
      <div className="documents-header">
        <div className="container-fluid">
          <div className="row align-items-center">
            <div className="col-md-8">
              <div className="header-content">
                <h1 className="page-title">
                  <i className="fas fa-folder-open me-3"></i>
                  {t("ged.gestion")}
                </h1>
                <p className="page-subtitle">
                  Gérez tous vos documents et dossiers en un seul endroit
                </p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="header-actions">
                <Button
                  className="btn btn-outline-primary me-2"
                  onClick={() => setShowModal(true)}
                >
                  <i className="fas fa-folder-plus me-2"></i>
                  {t("ged.nouveauDos")}
                </Button>
                <Button
                  className="btn btn-primary"
                  onClick={() => setShowDocumentModal(true)}
                >
                  <i className="fas fa-file-upload me-2"></i>
                  {t("ged.nouveauDoc")}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Search and Filters Section */}
      <div className="search-section">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="search-container">
                <div className="search-bar">
                  <Search className="search-icon" />
                  <Form.Control
                    type="text"
                    placeholder={t("ged.recherche")}
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    onKeyPress={(e) => {
                      if (e.key === "Enter") handleSearch();
                    }}
                    className="search-input"
                  />
                  <Button 
                    className="search-btn"
                    onClick={handleSearch}
                  >
                    <i className="fas fa-search"></i>
                  </Button>
                </div>
                <div className="filter-options">
                  <Button variant="outline-secondary" className="filter-btn">
                    <i className="fas fa-filter me-2"></i>
                    Filtres
                  </Button>
                  <Button variant="outline-secondary" className="sort-btn">
                    <i className="fas fa-sort me-2"></i>
                    Trier
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Stats Cards */}
      <div className="stats-section">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-3">
              <div className="stat-card">
                <div className="stat-icon">
                  <i className="fas fa-folder"></i>
                </div>
                <div className="stat-content">
                  <h3>{folders.length}</h3>
                  <p>Dossiers</p>
                </div>
              </div>
            </div>
            <div className="col-md-3">
              <div className="stat-card">
                <div className="stat-icon">
                  <i className="fas fa-file"></i>
                </div>
                <div className="stat-content">
                  <h3>{documentSearchResults.length}</h3>
                  <p>Documents</p>
                </div>
              </div>
            </div>
            <div className="col-md-3">
              <div className="stat-card">
                <div className="stat-icon">
                  <i className="fas fa-search"></i>
                </div>
                <div className="stat-content">
                  <h3>{folderSearchResults.length + documentSearchResults.length}</h3>
                  <p>Résultats</p>
                </div>
              </div>
            </div>
            <div className="col-md-3">
              <div className="stat-card">
                <div className="stat-icon">
                  <i className="fas fa-clock"></i>
                </div>
                <div className="stat-content">
                  <h3>24h</h3>
                  <p>Dernière MAJ</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="main-content">
        <div className="container-fluid">
          {/* Search Results */}
          {(folderSearchResults.length > 0 || documentSearchResults.length > 0) && (
            <div className="search-results">
              {folderSearchResults.length > 0 && (
                <div className="results-section">
                  <div className="section-header">
                    <h3 className="section-title">
                      <i className="fas fa-folder me-2"></i>
                      {t("ged.resutatDos")} ({folderSearchResults.length})
                    </h3>
                  </div>
                  <div className="results-grid">
                    {folderSearchResults.map((f) => (
                      <FolderCard key={f._id} folder={f} />
                    ))}
                  </div>
                </div>
              )}

              {documentSearchResults.length > 0 && (
                <div className="results-section">
                  <div className="section-header">
                    <h3 className="section-title">
                      <i className="fas fa-file me-2"></i>
                      {t("ged.resultatDoc")} ({documentSearchResults.length})
                    </h3>
                  </div>
                  <div className="results-grid">
                    {documentSearchResults.map((doc) => (
                      <DocumentCard key={doc._id} doc={doc} />
                    ))}
                  </div>
                </div>
              )}
            </div>
          )}

          {/* Root Folders */}
          <div className="folders-section">
            <div className="section-header">
              <h2 className="section-title">
                <i className="fas fa-home me-2"></i>
                {t("ged.racin")}
              </h2>
              <div className="view-options">
                <Button variant="outline-secondary" size="sm" className="me-2">
                  <i className="fas fa-th me-1"></i>
                  Grille
                </Button>
                <Button variant="outline-secondary" size="sm">
                  <i className="fas fa-list me-1"></i>
                  Liste
                </Button>
              </div>
            </div>
            
            {folders.length === 0 ? (
              <div className="empty-state">
                <div className="empty-icon">
                  <i className="fas fa-folder-open"></i>
                </div>
                <h4>Aucun dossier</h4>
                <p>Commencez par créer votre premier dossier</p>
                <Button 
                  className="btn btn-primary"
                  onClick={() => setShowModal(true)}
                >
                  <i className="fas fa-plus me-2"></i>
                  Créer un dossier
                </Button>
              </div>
            ) : (
              <div className="folders-grid">
                {folders.map((f) => (
                  <FolderCard key={f._id} folder={f} />
                ))}
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Modal création dossier */}
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
        style={{ borderRadius: "15px" }}
        className="modal-create-folder"
        id={"modal-create-folder"}>
        <Modal.Header closeButton>
          <Modal.Title>{t("ged.nouveauDos")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>{t("ged.nomDos")}</Form.Label>
              <Form.Control
                type="text"
                placeholder="Ecrire ....."
                value={newFolderName}
                onChange={(e) => setNewFolderName(e.target.value)}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label> {t("ged.option")} </Form.Label>
              <Form.Select
                value={parentId || ""}
                onChange={(e) => setParentId(e.target.value || null)}>
                <option value="">{t("ged.rac")}</option>
                {renderFolderOptions(foldersChild)}
              </Form.Select>
            </Form.Group>

            <Button onClick={createFolder} className="w-100 btn-create">
              {t("ged.creer")}
            </Button>
          </Form>
        </Modal.Body>
      </Modal>

      {/* Modal création document */}
      <CreateDocumentModal
        show={showDocumentModal}
        handleClose={() => setShowDocumentModal(false)}
        onDocumentCreated={(doc) => console.log("Document créé:", doc)}
        foldersAdd={foldersAdd}
      />
    </div>
  );
};

export default FolderManager;
